__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("gqlclient", "0.0.0", () => (Promise.all([__webpack_require__.e(267), __webpack_require__.e(603), __webpack_require__.e(3), __webpack_require__.e(16)]).then(() => (() => (__webpack_require__(68016))))));
			register("product-hub", "0.0.0", () => (Promise.all([__webpack_require__.e(3), __webpack_require__.e(516), __webpack_require__.e(240), __webpack_require__.e(200)]).then(() => (() => (__webpack_require__(41200))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(233), __webpack_require__.e(3)]).then(() => (() => (__webpack_require__(31233))))));
			register("react", "18.3.1", () => (__webpack_require__.e(444).then(() => (() => (__webpack_require__(8444))))));
			register("secure-file-content", "0.0.0", () => (Promise.all([__webpack_require__.e(349), __webpack_require__.e(323), __webpack_require__.e(73), __webpack_require__.e(3), __webpack_require__.e(715), __webpack_require__.e(516), __webpack_require__.e(240), __webpack_require__.e(701), __webpack_require__.e(48)]).then(() => (() => (__webpack_require__(11701))))));
			register("ui", "0.0.0", () => (Promise.all([__webpack_require__.e(267), __webpack_require__.e(349), __webpack_require__.e(323), __webpack_require__.e(277), __webpack_require__.e(303), __webpack_require__.e(3), __webpack_require__.e(715), __webpack_require__.e(516), __webpack_require__.e(470), __webpack_require__.e(480)]).then(() => (() => (__webpack_require__(97480))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(917).then(() => (() => (__webpack_require__(66917))))));
			initExternal(41771);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};